import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-mensagem-dialog",
  templateUrl: "./mensagem-dialog.component.html",
})
export class MensagemDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<MensagemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  fechar(): void {
    this.dialogRef.close();
  }
}
